import Vue from 'vue'
import suppliesTransformer from '@/transformers/purchase/supplies'

/**
 * @author Mariela T. TL <mariela.temozihui@jbge.com.mx>
 *
 *
 * List Supplies by OC
 *
 * @return {Object}
 */

const fetchSuppliesABC = (folio) =>
  Vue.$http.get(`purchase/buy_order/abc/${folio}/`)
    .then(response => {
      return suppliesTransformer.fetch(response.data)
    })
    .catch(err => { throw err })

export default fetchSuppliesABC



// WEBPACK FOOTER //
// ./src/services/purchase/fetchSuppliesABC.js